/**
 * Dice Store — shared contract between client (display) and server (enforcement).
 *
 * The store shows a weekly rotation of store-available dice (Fortnite-style):
 * the same set for every player, deterministically shuffled by week number,
 * reshuffling every Monday. A die is unlocked by spending EITHER gold OR a
 * single dice token; the prices below are the single source of truth so the
 * client's price tags and the server's spend check can never drift.
 */
/**
 * Gold price per rarity tier (the label artists pick in the dice editor).
 * A doubling-ish ladder from Common 100 up to Exotic 10000. A die's store
 * rarity is its FIRST tier's label; unknown/missing falls back to Common.
 */
export const DICE_STORE_RARITY_GOLD = {
    Common: 100,
    Uncommon: 250,
    Rare: 500,
    Epic: 1000,
    Legendary: 2500,
    Mythic: 5000,
    Exotic: 10000,
};
/** Fallback gold price when a die has no recognized rarity label. */
export const DICE_STORE_DEFAULT_GOLD = 100;
/**
 * Rarities that CANNOT be bought with gold — a dice token is the only way in.
 * The top of the ladder (Exotic) is reserved for the token economy so gold can
 * never shortcut it. Both client (button gating) and server (spend guard) read
 * this same set, so they can't disagree on what's token-only.
 */
export const DICE_STORE_TOKEN_ONLY_RARITIES = new Set(['Exotic']);
/** True when a die's rarity may only be unlocked with a dice token. */
export function diceIsTokenOnly(rarity) {
    return !!rarity && DICE_STORE_TOKEN_ONLY_RARITIES.has(rarity);
}
/** Resolve a die's gold price from its rarity label. */
export function diceGoldPrice(rarity) {
    return (rarity && DICE_STORE_RARITY_GOLD[rarity]) || DICE_STORE_DEFAULT_GOLD;
}
/** Flat dice-token price for every store die (1 token = 1 unlock). */
export const DICE_STORE_TOKEN_PRICE = 1;
/** Max dice shown in the weekly rotation. Above this we shuffle + slice. */
export const DICE_STORE_ROTATION_SIZE = 15;
//# sourceMappingURL=DiceStore.js.map